import React, { useMemo } from 'react';
import SalesOverviewService from '../SalesOverviewService';

const SalesBreakdownCardServiceTransfer = (props: any) => {
  const { tabMapConfig, serviceType = 'top10', ...restProps } = props;

  const config = useMemo(() => {
    const { by_tab, by_metric, by_top10_metric } = props?.data || {};
    const config = tabMapConfig?.[by_tab] || {};
    const { isRefund, api } = config;
    // after refund特殊处理
    if (isRefund) {
      return {
        api,
        dataKey: serviceType === 'top10' ? by_top10_metric : by_metric,
        metric: serviceType === 'top10' ? by_top10_metric : by_metric,
      };
    }
    return config;
  }, [props?.data, tabMapConfig]);

  return (
    <SalesOverviewService serviceType={serviceType}  {...restProps} config={config}></SalesOverviewService>
  );
};

export default SalesBreakdownCardServiceTransfer;
